import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { PageHeader } from '../../../Common';
import Typography from '@material-ui/core/Typography';


const screenCode = 'MANUALLEAFCOLLECTION';

const useStyles = makeStyles({
    root: {
      minWidth: 275,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });

export function ManualLeafListing(props){
    const classes = useStyles();

    

    return (
        <Fragment>
            <div>
                <Card className={classes.root}>
                    <CardContent>
                    <PageHeader
                            title="Manual Leaf Collection"
                            isButtonEnable={true}
                            buttonText="Manual Leaf Entry"
                            path="manualLeafCollection/addEdit" />
                    </CardContent>
                    <CardActions>
                        <Button size="small">Learn More</Button>
                    </CardActions>
                </Card>
            </div>
        </Fragment>
    )
}